import { useSearchParams } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { useIntercom } from '@/reporting/Intercom';

const IntercomClickToChat = () => {
  const { openChat } = useIntercom();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffectOnce(() => {
    if (searchParams.get('clickToChat') === 'true') {
      openChat();

      // remove clickToChat parameter after opening chat
      searchParams.delete('clickToChat');
      setSearchParams(searchParams, { replace: true });
    }
  });

  return null;
};

export default IntercomClickToChat;
